<div #applePay id="apple-pay" class="apple-pay-button apple-pay-button-black  apple-pay-button-hidden" (click)="termsClickHandler()"></div>
